/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */

var klaviyo = klaviyo || [];

klaviyo.init({
  account: "V29FNB",
  platform: "shopify",
});
klaviyo.enable("backinstock",{
  trigger: {
    product_page_text: "Notificarme cuando esté disponible",
    product_page_class: "btn",
    product_page_text_align: "center",
    product_page_margin: "0px",
    replace_anchor: false,
  },
  modal: {
    headline: "{product_name}",
    body_content: "¡Anótate a la lista y te llegará un correo en cuanto volvamos a tener este producto disponible!",
    email_field_label: "Correo electrónico",
    button_label: "Anotarme",
    subscription_success_label: "Te avisaremos cuando esté de vuelta.",
    footer_content: '',
    additional_styles: "@import url(//www.portomundo.mx/cdn/shop/t/18/assets/bundle.main.min.css?v=42173228115309450381724278689);",
    drop_background_color: "#000",
    background_color: "#fff",
    text_color: "#222",
    button_text_color: "#fff",
    button_background_color: "#439fdb",
    close_button_color: "#ccc",
    error_background_color: "#fcd6d7",
    error_text_color: "#C72E2F",
    success_background_color: "#d3efcd",
    success_text_color: "#1B9500",
    close_label: 'Cerrar',
  },
});
